// src/environments/environment.dev.ts
// Usado por: ng build --configuration=dev (deploy staging)
// FastAPI Middleware — Staging

export const python = {
  api: 'https://staging.api.middleware.cic-ware.com/api',
  api_support: 'https://staging.api.soporte.cic-ware.com/api' // Support FastAPI — Staging
};

// 🌍 API Pública MasCredimas — Staging
export const pythonPublico = {
  api: 'https://api-pub-dev.mascredimas.us/api'
};

export const env = {
  production: false,
  debugMode: false,

  /*
   * Variables PHP Legacy eliminadas — ya no se referencian en ningun servicio.
   * Si en el futuro se necesita un segmento de ruta configurable por ambiente,
   * agregarlo aqui y apuntar a un endpoint de FastAPI.
   *
   * Variables que existian:
   *   url_base        — URL base del backend PHP (https://staging.api.middleware.cic-ware.com)
   *   api             — Segmento de ruta PHP (/api-1)
   *   api_end         — Archivo PHP de entrada (/api.php)
   *   api_gaming      — Segmento PHP para gaming (/games_licencias)
   *   api_gaming_end  — Archivo PHP de gaming (/game_licencias.php)
   *   module.mailing_admin — Ruta PHP para envio de correos (/administracion/mailing.php)
   *                          El envio de correo debe implementarse en FastAPI:
   *                          el backend lo dispara internamente al crear un empleado.
   *   module.ia_general_asis  — Ruta PHP para IA general
   *   module.agenteAPI        — Ruta PHP para agente
   *   module.asistenteAudio   — Ruta PHP para audio de asistente
   *   module.gemini_audio     — Ruta PHP para audio Gemini
   */

  // FastAPI Middleware — Staging
  apiUrl: 'https://staging.api.middleware.cic-ware.com/api',

  // POS Don Lucho — DEV
  posUrl: 'https://dev.pos.cic-ware.com/entrada/entrada.php',

  module: {
    entorno: 'DESARROLLO',

    user: {
      getUsers: 'users/users',
      getUser: 'users/user/:id',
      createUser: 'users/user',
      updateUser: 'users/user/:id',
      deleteUser: 'users/user/:id',
      api_user: 'http://127.0.0.1:8000/'
    },

    authAzure: {
      tenantAzureId: '6cdfbc33-3f56-4134-822c-e24936dea384',
      clientAzureId: '6104bfd1-615e-4d4e-9878-5adea1963e4c',
      redirectUri: 'http://localhost:4200',
      postLogoutRedirectUri: 'http://localhost:4200/login',
      authorizeEndpoint: 'https://login.microsoftonline.com/6cdfbc33-3f56-4134-822c-e24936dea384/oauth2/v2.0/authorize',
      tokenEndpoint: 'https://login.microsoftonline.com/6cdfbc33-3f56-4134-822c-e24936dea384/oauth2/v2.0/token',
      userInfoEndpoint: 'https://graph.microsoft.com/oidc/userinfo',
      logoutEndpoint: 'https://login.microsoftonline.com/6cdfbc33-3f56-4134-822c-e24936dea384/oauth2/v2.0/logout',
      scopes: ['openid', 'profile', 'email', 'offline_access']
    },

    authGoogle: {
      clientId: '646693662907-68m1vov940kciee5v02clui456odaaaa.apps.googleusercontent.com',
      redirectUri: 'http://localhost:4200/oauth-callback',
      postLogoutRedirectUri: 'http://localhost:4200/login'
    }
  }
};
